module.exports = __webpack_public_path__ + "48aa7ad98beedc63d82925f45fd8e72c.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensans.woff2
// module id = 669
// module chunks = 57